import * as React from 'react';

import type { EventProcedureStepAPIType } from 'security-app/hooks/api/eventProceduresAPI.types';

import StepGoToDashboard from './StepGoToDashboard';
import StepGoToLink from './StepGoToLink';
import StepSendNotification from './StepSendNotification';
import StepPerformSearch from './StepPerformSearch';

type Props = {
  eventId?: string;
  step: EventProcedureStepAPIType;
};

function StepActionsButton({ step, eventId = undefined }: Props) {
  switch (step?.action?.config?.type) {
    case 'go_to_dashboard':
      return <StepGoToDashboard config={step?.action?.config} />;
    case 'link':
      return <StepGoToLink config={step?.action?.config} />;
    case 'execute_notification':
      return <StepSendNotification config={step?.action?.config} eventId={eventId} />;
    case 'perform_search':
      return <StepPerformSearch config={step?.action?.config} eventId={eventId} />;
    default:
      return null;
  }
}

export default StepActionsButton;
